module.exports = __webpack_public_path__ + "static/media/car_loading.f9eecca9.png";